import React from 'react'
import styled from 'styled-components'
import AppModal from './common/AppModal'
import Notifications from './common/Notifications'
import Header from './header/Header'
import useFetch429Interceptor from './hooks/useFetch429Interceptor'
import useViewTracking from './hooks/useViewTracking'
import { Router } from './routes'
import './common/modals'
import { useSetAppElement } from '@maui/elements'

const AppContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  > main {
    flex: 1;
    padding: 16px;
    display: flex;
    flex-direction: column;
  }
`

export default function App() {
  useFetch429Interceptor()
  useViewTracking()
  useSetAppElement('#main')

  return (
    <AppContainer>
      <Header />
      <main id="main">
        <Router />
      </main>
      <AppModal />
      <Notifications />
    </AppContainer>
  )
}
